<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kiriman</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.kiriman_name" :state="!$v.model.kiriman_code.$error" readonly placeholder="Kode Kiriman"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
            <b-input-group>
              <b-input-group-prepend><label>Uraian Promo</label></b-input-group-prepend>
              <b-form-input v-model="model.campaignname" :state="!$v.model.campaignname.$error" ></b-form-input>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <label>Target Penerima</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.linetype"
                :options="linetype"
                class="mb-1"
                :state="!$v.model.linetype.$error"
                :disabled="disabledInput"
                :plain="true"
              >
                <template v-slot:first>
                  <option :value="null" disabled>-- Please select an option --</option>
                </template>
              </b-form-select>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <!-- <label>{{pemesanText}}</label> -->
                <label> Nama Penerima </label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.CustName"
                @keyup.13.native="showMdlPemesan"
                :state="!$v.model.pemesan_id.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn
                  text="Button"
                  id="btnKoranCust"
                  @click="showMdlPemesan"
                  :disabled="disabledInput"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <span v-if="model.linetype !== 2">
              <!-- <b-input-group>
                <b-input-group-prepend>
                  <label>Alamat Penagihan</label>
                </b-input-group-prepend>
                <b-form-input v-model="customer.billingAddr1" readonly></b-form-input>
              </b-input-group>
              <b-input-group label-cols-md="2">
                <b-input-group-prepend>
                  <label></label>
                </b-input-group-prepend>
                <b-form-input v-model="customer.billingAddr2" readonly></b-form-input>
              </b-input-group> -->
              <b-input-group>
                <b-input-group-prepend>
                  <label>Alamat Pengiriman</label>
                </b-input-group-prepend>
                <b-form-textarea v-model="model.DeliveryAddr" :state="!$v.model.DeliveryAddr.$error" rows="2" max-rows="5"></b-form-textarea>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Telephone</label>
                </b-input-group-prepend>
                <b-form-input v-model="customer.PhoneNo" readonly></b-form-input>
              <b-input-group-prepend>
                <span class="p-2">Sales/AE</span>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.salesae_name"
                @keyup.13.native="lkuKoranSalesShow=true"
                placeholder="Pilih Sales Executive"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
              </b-input-group>
            </span>
            <span v-else>
              <b-input-group>
                <b-input-group-prepend>
                  <label>NIK</label>
                </b-input-group-prepend>
                <b-form-input v-model="customer.crewnik" readonly></b-form-input>
              </b-input-group>
            </span>

            <br />
          </b-col>

          <b-col cols="6">
            <b-input-group>
              <b-input-group-prepend>
                <label>Periode </label>
              </b-input-group-prepend>
              <b-form-input
                type="date"
                v-model="model.startdate"
                :state="!$v.model.startdate.$error"
              ></b-form-input>

              <b-input-group-prepend>
                <span class="input-group-text">-</span>
              </b-input-group-prepend>
              <b-form-input
                type="date"
                v-model="model.enddate"
                :state="!$v.model.enddate.$error"
              ></b-form-input>

              <b-form-invalid-feedback
                v-show="!statePeriodDate"
                class="text-left"
                style="display:unset;"
              >Masukan tanggal periode yang valid.</b-form-invalid-feedback>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Kota Layanan</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.kota_name"
                @keyup.13.native="lkuKoranKotaShow=true"
                :state="!$v.model.kota_id.$error"
                placeholder="Pilih Kota/Area"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranKotaShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jurusan</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.jurusan_info"
                @keyup.13.native="lkuKoranJurusanShow=true"
                :state="!$v.model.jurusan_id.$error"
                placeholder="Pilih Jurusan"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group>
              <b-input-group-prepend>
                <label>Titip Kirim ke</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.namaAgentDititip"
                :key="model.kirimtitipke"
                ref="inputtitipanagen"
                @keyup.13.native="lkuKoranAgenShow=true"
                placeholder="Pilih Agent"
                :state="stateTititpKirimKe"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" id="btnKoranAgen" @click="lkuKoranAgenShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
                <b-btn text="Button" id="btnKoranAgenCleat" v-on:click="clearTitipanAgen()">
                  <i class="fa fa-close"></i>
                </b-btn>
              </b-input-group-append>
              <b-form-invalid-feedback class="text-right">{{errMsgTitipKirim}}</b-form-invalid-feedback>
            </b-input-group> -->
            <b-input-group>
              <b-input-group-prepend>
                <label>Titik Drop</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.titikdrop" placeholder="Drop point"></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuKoranAgenShow=true" v-b-tooltip.hover title="Drop ke Agen (Kirim via Agen)">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group label-cols-md="2">
              <b-input-group-prepend>
                <label>Jumlah Kiriman</label>
              </b-input-group-prepend>
              <div style="width:100px;">
                <v-number class="form-control" separator="," v-model="model.gratis"></v-number>
              </div>
              <b-input-group-append>
                <span class="input-group-text">Eksemplar Koran</span>
              </b-input-group-append>              
            </b-input-group>
            <b-input-group label-cols-md="2" label="Hari">
              <b-input-group-prepend>
                <label>Pilihan Hari</label>
              </b-input-group-prepend>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="model.selected"
                :options="effdtoptions"
                name="flavour-1"
              ></b-form-checkbox-group>
              <b-form-invalid-feedback
                style="display:unset;"
                v-show="$v.model.selected.$error"
                id="input-1-live-feedback"
              >Minimal pilih 1 hari</b-form-invalid-feedback>
            </b-input-group> -->
          <div class="mt-1">
            <p class="text-center font-weight-bolder mb-1" style="width:100%; background-color:gold;">Pola Kiriman  GRATIS </p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Senin</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Selasa</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Rabu</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Kamis</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Jumat</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Sabtu</th>
                  <th style="width:80px;padding-top:0;padding-bottom:0;">Minggu</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.seninEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.selasaEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.rabuEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.kamisEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.jumatEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.sabtuEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                  <td style="padding:0;">
                    <b-input-group>
                        <v-number
                          class="form-control text-right"
                          separator=","
                          v-model="model.mingguEcer"
                        ></v-number>
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          </b-col>
        </b-row>
      <br />
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
          <i class="fa fa-save"></i> Save
        </button>
        <b-button class="btn btn-primary mr-1" @click.stop="close()">
          <i class="fa fa-close"></i> Close
        </b-button>
      </b-row>
    </b-card>

    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" :title="pemesanText" :centered="true"> 
      <lku-koran-cust v-if="model.linetype === 1" @click="onSelectKoranCust"></lku-koran-cust> 
      <lku-salesae v-if="model.linetype === 2" @click="onSelectKoranCust" crudfilter="koran=1"></lku-salesae> 
      <!-- <lku-koran-cust v-if="model.linetype === 3" @click="onSelectKoranCust" customer_group="NONCUSTOMER"></lku-koran-cust>  -->
      <lku-koran-noncustomer v-if="model.linetype === 3" @click="onSelectKoranCust"></lku-koran-noncustomer>
    </b-modal>

    <b-modal v-model="lkuKoranAgenShow" size="lg" :hide-footer="true" title="List of Agent" :centered="true" >
      <lku-koran-cust @click="onSelectKoranAgen" :customer_group="koranagngroup"></lku-koran-cust>
    </b-modal>

    <b-modal v-model="lkuKoranJurusanShow" size="lg" :hide-footer="true" title="Daftar Jurusan/Ekspedisi" :centered="true"> 
      <lku-koran-jurusan @click="onSelectKoranJurusan"></lku-koran-jurusan>
    </b-modal>

    <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="Daftar Kota Layanan" :centered="true">
      <lku-koran-kota @click="onSelectKoranKota"></lku-koran-kota>
    </b-modal>
    <b-modal v-model="lkuKoranKirimanCodeShow" size="lg" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman" crudfilter="gratis=1"></lku-koranjeniskiriman>
    </b-modal>

    <b-modal v-model="lkuKoranSalesShow" size="lg" :hide-footer="true" title="List of Sales" :centered="true">
      <lku-salesae @click="onSelectSalese" crudfilter="koran=1"></lku-salesae>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>

  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import vNumber from "vue-numeric";
import crud from "../../apis/crud";
// import customer from "../../apis/customer";
// import noncustomer from "../../apis/koran_noncustomer";
import koran_pesanan from "../../apis/koran_pesanan_gratis";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";
import lkuKoranCust from "../lookup/lkuKoranCust";
import lkuKoranNoncustomer from "../lookup/lkuKoranNonCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuKoranJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranKota from "../lookup/lkuKoranKota";
import moment from "moment";
toastr.init();

export default {
  components: {
    lkuKoranjeniskiriman,
    lkuKoranNoncustomer,
    lkuKoranCust,
    lkuSalesae,
    lkuKoranJurusan,
    lkuKoranKota,
    vNumber, Loading
  },
  mixins: [validationMixin],
  validations: {
    model: {
      campaignname: { required },
      kiriman_code: {required},
      linetype: { required },
      pemesan_id: { required },
      DeliveryAddr: { required },
      startdate: { required },
      enddate: { required },
      kota_id: { required },
      jurusan_id: { required },
    }
  },
  data() {
    return {
      isLoading: false,
      saveEnabled: true,
      lkuKoranKirimanCodeShow: false,
      dateSelectedDisabled: false,
      lkuKoranCustShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKotaShow: false,
      lkuKoranSalesShow: false,
      koranagngroup: "KORANAGEN",
      lkuKoranAgenShow: false,
      stateTititpKirimKe: true,
      errMsgTitipKirim: null,
      model: {
        campaignKey: null,
        campaignname: '',
        linetype: null,
        pemesan_id: null,
        startdate: null,
        enddate: null,
        kota_id: null,
        jurusan_id: null,
        DeliveryAddr: null,
        seninEcer:0,
        selasaEcer: 0,
        rabuEcer: 0,
        kamisEcer: 0,
        jumatEcer: 0,
        sabtuEcer: 0,
        mingguOk: 0
      },
      customer: {},
      salesae: [],
      campaign: {
        name: null,
        periode: null
      },
      pemesanText: 'Customer (agen/langganan)',
      linetype: [{value:1,text:'Customer (agen/langganan)'},{value:2,text:'Sales/Canvaser'}, {value:3,text:'Prospek/Relasi/lainnya'}],
      korankota: [],
      effdtoptions: [
        { text: "Monday", value: "seninOk" },
        { text: "Tuesday", value: "selasaOk" },
        { text: "Wednesday", value: "rabuOk" },
        { text: "Thursday", value: "kamisOk" },
        { text: "Friday", value: "jumatOk" },
        { text: "Saturday", value: "sabtuOk" },
        { text: "Sunday", value: "mingguOk" }
      ],
      optionKolomKiriman: [
        { text: "Promosi", value: "promosi" },
        { text: "Gratis", value: "gratis" },
        { text: "Bonus", value: "bonus" },
        { text: "lain", value: "lain" }
      ],
      disabledInput: false,
      startdate: null,
      enddate: null
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    jumlahHari() {
      if (this.model.startdate && this.model.enddate) {
        var a = moment(this.model.enddate);
        var b = moment(this.model.startdate);
        return a.diff(b, "days") + 1;
      } else {
        return 0;
      }
    },

    changeLineType() {
      return this.model.linetype;
    },
    statePeriodDate(startdate, enddate) {
      startdate = this.model.startdate;
      enddate = this.model.enddate;
      var a = moment(enddate);
      var b = moment(startdate);
      if (a.diff(b, "days") < 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  created: async function() {
      if (this.$route.params.tablekey) {
          const [a,detail] = await Promise.all([
            crud.list({ tablename: "korancampaignlinetype" }),koran_pesanan.detail(this.$route.params)
          ]);
          if (a.length>0){
              this.linetype = a.reduce((newArr = [], el, idx) => {
                newArr.push({
                  value: el.linetype,
                  text: `${el.linename}`
                });
                return newArr;
              }, []);
          }
        this.model = detail;
        this.model.campaignstartdate = moment(detail.campaignstartdate).format(
          "YYYY-MM-DD"
        );
        this.model.campaignenddate = moment(detail.campaignenddate).format(
          "YYYY-MM-DD"
        );
        this.model.jurusan_info =
          this.model.jurusan_code + " | " + this.model.jurusan_name;


        this.disabledInput = true;
      } else {
        const a = await crud.list({ tablename: "korancampaignlinetype" });
        if (a.length>0){
            this.linetype = a.reduce((newArr = [], el, idx) => {
              newArr.push({
                value: el.linetype,
                text: `${el.linename}`
              });
              return newArr;
            }, []);
        }
      }
    this.$watch('changeLineType', function(newVal) {
            this.model.pemesan_id = '';
            this.model.CustName= '';
            this.model.CustCode= '';
            this.model.DeliveryAddr='';
      const tagetPenerima= this.linetype.find(l=>l.value==newVal);
      if (tagetPenerima) {
        this.pemesanText= tagetPenerima.text;
      }

    });            


  },
  methods: {
    onSelectSalese:  function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.salesae_name = `${_sales.crewname || _sales.salesae_name}`;
      this.lkuKoranSalesShow = false;
    },
    onSelectKoranJurusan: async function(_selected) {
      this.model.jurusan_id = _selected.jurusan_id;
      this.model.jurusan_name = _selected.jurusan_name;
      this.model.jurusan_info =
        _selected.jurusan_code + " | " + _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranKota: async function(_selected) {
      this.model.kota_id = _selected.kota_id;
      this.model.kota_name = _selected.kota_name;
      if (_selected.salesae_id){
         if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = `${_selected.crewname || _selected.salesae_name}`;
         }          
      }
      this.lkuKoranKotaShow = false;
    },

    onSelectKoranJenisKiriman: function(_selected) {
      this.model.kiriman_name = _selected.kiriman_name;
      this.model.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    onSelectKoranCust(_selected) {
      if (
        _selected &&
        (_selected.customer_id || _selected.salesae_id || _selected.noncust_id)
      ) {
        if (this.model.linetype === 1) {
          if (
            (this.model.kirimtitipke || this.model.kirimtitipke !== null) &&
            this.model.kirimtitipke === _selected.customer_id
          ) {
            this.stateTititpKirimKe = false;
            this.errMsgTitipKirim = "Pilih Customer yang berbeda dg Agen untuk dititipkan.";
            this.lkuKoranCustShow = false;
          } else {
            this.model.pemesan_id = _selected.customer_id;
            this.model.CustName= _selected.CustName;
            this.model.CustCode= _selected.CustCode;
            // if (_selected.DeliveryAddr){
            //   this.model.DeliveryAddr = _selected.DeliveryAddr;
            // } else {
            //   this.model.DeliveryAddr =
            //     _selected.Address1 +
            //     `${_selected.Address2 !== null ? _selected.Address2 : ""}` +
            //     " ." +
            //     _selected.City;
            // }

          if (_selected.DeliveryAddr) {
            this.model.DeliveryAddr = _selected.DeliveryAddr;
          } else {
            this.model.DeliveryAddr = `${_selected.Address1} ${
              _selected.Address2 !== null ? _selected.Address2 : ""
                } ${_selected.City}`;
          }

            this.stateTititpKirimKe = true;
            this.errMsgTitipKirim = null;
          }
        } else if (this.model.linetype === 2) {
          if (
            (this.model.kirimtitipke || this.model.kirimtitipke !== null) &&
            this.model.kirimtitipke === _selected.salesae_id
          ) {
            this.stateTititpKirimKe = false;
            this.errMsgTitipKirim = "Pilih Customer  yang berbeda dg Agen untuk dititipkan.";
            this.lkuKoranCustShow = false;
          } else {
            this.model.pemesan_id = _selected.salesae_id;
            this.model.CustName= _selected.salesae_name;
            this.model.CustCode= '';
            this.stateTititpKirimKe = true;
            this.errMsgTitipKirim = null;
          }
        } else if (this.model.linetype === 3) {
          if (
            (this.model.kirimtitipke || this.model.kirimtitipke !== null) &&
            this.model.kirimtitipke === _selected.salesae_id
          ) {
            this.stateTititpKirimKe = false;
            this.errMsgTitipKirim = "Pilih Customer yang berbeda dg Agen untuk dititipkan.";
            this.lkuKoranCustShow = false;
          } else {
            this.model.pemesan_id = _selected.noncust_id;
            this.model.CustName= _selected.CustName;
            this.model.CustCode= '';
            this.model.DeliveryAddr = _selected.DeliveryAddr;
            this.stateTititpKirimKe = true;
            this.errMsgTitipKirim = null;
          }
        }


        if (!(this.model.salesae_id)) {
          this.model.salesae_id = _selected.salesae_id;
          this.model.salesae_name = _selected.salesae_name;
        }
        if (!(this.model.kota_id)) {
          this.model.kota_id = _selected.kota_id;
          this.model.kota_name = _selected.kota_name;
        }
        if (!(this.model.jurusan_id)) {
          this.model.jurusan_id = _selected.jurusan_id;
          this.model.jurusan_name = _selected.jurusan_name;
          this.model.jurusan_info = _selected.jurusan_code + " | " + _selected.jurusan_name;
        }
        if (!(this.model.titikdrop)) {
          this.model.titikdrop = _selected.titikdrop;
        }

        this.lkuKoranCustShow = false;
      }
    },
    // onSelectKoranAgen(_selected) {
    //   if (this.model.pemesan_id === null) {
    //     this.lkuKoranAgenShow = false;
    //     this.stateTititpKirimKe = false;
    //     this.errMsgTitipKirim = "Pilih target campaign terlebih dahulu.";
    //     this.invalidModel;
    //   } else if (
    //     _selected.customer_id &&
    //     this.model.pemesan_id === _selected.customer_id
    //   ) {
    //     this.lkuKoranAgenShow = false;
    //     this.stateTititpKirimKe = false;
    //     this.errMsgTitipKirim = "Pilih agen yang berbeda untuk dititipkan.";
    //   } else if (_selected && _selected.customer_id) {
    //     this.model.namaAgentDititip = `${_selected.CustName} | ${_selected.CustCode}`;
    //     this.model.kirimtitipke = _selected.customer_id;
    //     this.lkuKoranAgenShow = false;
    //   }
    // },
    onSelectKoranAgen(_selected) {
      if (this.model.noncust_id === _selected.customer_id) {
            toastr.error("Pilih Customer yang berbeda !.");
      } else {
          this.model.titikdrop = _selected.CustName;
          this.lkuKoranAgenShow = false;
      }
    },
    clearTitipanAgen() {
      this.model.namaAgentDititip = null;
      this.model.kirimtitipke = null;
      this.$refs.inputtitipanagen.setValue("");
    },
    showMdlPemesan() {
      if (this.model.linetype !== null) {
        this.lkuKoranCustShow = true;
      } else {
        toastr.error(
          "Mohon pilih line type terlebih dahulu.",
          "ERROR MESSAGE",
          10000
        );
      }
    },
    save: async function() {
      if (this.invalidModel) {
          const invalidobj={};
          for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
              if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
            }
          }        
          console.log('validation model: ', this.$v.model);
          console.log('validation field: ', invalidobj);

        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (!this.statePeriodDate) {
        toastr.error("Masukkan periode tanggal yang valid.", "ERROR MESSAGE");
        this.$refs.inputStartDate.focus();
      } else {
        try {
                this.isLoading=true;
          this.model.startdate = moment(this.model.startdate).format(
            "YYYY-MM-DD"
          );
          this.model.enddate = moment(this.model.enddate).format("YYYY-MM-DD");
          await koran_pesanan.save(this.model);
          toastr.success("Pesanan berhasil disimpan");
          this.isLoading=false;
          this.close();
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },
    close() {
      // if (this.$store.state.prevRoute.name) {
      //   router.push({ name: this.$store.state.prevRoute.name });
      // } else {
      //   router.push({ name: "koran.customer" });
      // }
      router.push({ name: "koran.pesanancampaign" });
    }
  }
};
</script>